var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4515_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7549 31.7227H11.8623L8.51758 41H3.68359L17.2578 5.45312H21.3594L34.958 41H30.1484L26.7549 31.7227ZM13.2783 27.8652H25.3633L19.3086 11.2393L13.2783 27.8652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5901 47.6806C29.9383 48.0597 30.3517 48.3604 30.8066 48.5656C31.2616 48.7708 31.7492 48.8764 32.2417 48.8764H35.8033C36.7979 48.8764 37.7517 48.4462 38.455 47.6806L51.2583 33.7424C51.9616 32.9768 52.3566 31.9384 52.3566 30.8557C52.3566 29.773 51.9616 28.7347 51.2583 27.969L45.955 22.1956C45.2517 21.4301 44.2979 21 43.3034 21C42.3088 21 41.355 21.4301 40.6517 22.1956L26.0676 38.0725C25.3644 38.8381 24.9693 39.8765 24.9693 40.9592C24.9693 42.0419 25.3644 43.0803 26.0676 43.8459L29.5901 47.6806ZM41.9775 23.6391C42.1516 23.4495 42.3583 23.2992 42.5858 23.1966C42.8133 23.094 43.0571 23.0412 43.3033 23.0412C43.5495 23.0412 43.7933 23.094 44.0208 23.1966C44.2483 23.2992 44.455 23.4495 44.6291 23.6391L49.9325 29.4125C50.1066 29.602 50.2447 29.827 50.339 30.0747C50.4332 30.3223 50.4817 30.5877 50.4817 30.8558C50.4817 31.1238 50.4332 31.3893 50.339 31.6369C50.2447 31.8846 50.1066 32.1096 49.9325 32.2991L43.3034 39.5158L35.3484 30.8558L41.9775 23.6391ZM53 53.9794C53.0001 54.1135 52.9759 54.2462 52.9288 54.3701C52.8817 54.4939 52.8126 54.6065 52.7256 54.7012C52.6385 54.796 52.5351 54.8712 52.4214 54.9225C52.3076 54.9737 52.1856 55.0001 52.0625 55H23.9375C23.6889 55 23.4504 54.8925 23.2746 54.7011C23.0988 54.5097 23 54.2501 23 53.9794C23 53.7087 23.0988 53.4491 23.2746 53.2577C23.4504 53.0663 23.6889 52.9588 23.9375 52.9588H52.0625C52.1856 52.9587 52.3076 52.9851 52.4214 53.0363C52.5351 53.0876 52.6385 53.1628 52.7256 53.2576C52.8126 53.3523 52.8817 53.4649 52.9288 53.5887C52.9759 53.7126 53.0001 53.8454 53 53.9794V53.9794Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4515_3872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearTextIcon);
export default __webpack_public_path__ + "static/media/clearTextIcon.7ed2c66e734fa76d7913446d25568271.svg";
export { ForwardRef as ReactComponent };